import axios from "@/api/axios";

export async function createRoom({ officeId, officeName, roomName, qualification = 0, ip, platformType }) {
  const { data } = await axios.post(`/rooms`, {
    officeId,
    officeName,
    roomName,
    qualification,
    ip,
    platformType,
  });
  return data;
}

export async function updateRoom(id, { roomName, qualification, ip, platformType, officeId, officeName }) {
  const { data } = await axios.patch(`/rooms/${id}`, {
    ...(roomName != null ? { roomName } : {}),
    ...(qualification != null ? { qualification } : {}),
    ...(ip != null ? { ip } : {}),
    ...(platformType != null ? { platformType } : {}),
    ...(officeId != null ? { officeId } : {}),
    ...(officeName != null ? { officeName } : {}),
  });
  return data;
}

export async function setRoomEnable(id, isEnable) {
  const { data } = await axios.patch(`/rooms/enables/${id}`, { isEnable });
  return data;
}

export async function setRoomOperation(id, inOperation) {
  const payload = {
    isEnable: inOperation,
    roomStatus: inOperation ? "available" : "retired",
  };
  const { data } = await axios.patch(`/rooms/enables/${id}`, payload);
  return data;
}
